export const PLAN_LEVELS = {
  FREE: 0,
  BASIC: 1,
  GROWTH: 2,
  PRO: 3
};

export const PLAN_MAPPING = {
  "GOLD": "BASIC",
  "DIMOND": "GROWTH",
  "PLATINUM": "PRO",
  "SILVER": "GROWTH",
  "BRONZE": "BASIC"
};

export const canCreateBusiness = (planLevel, businessCount) =>
  businessCount === 0 || planLevel >= PLAN_LEVELS.PRO;

export const getEffectivePlan = (user, business, hasBusinessContext) => {
  const subscriptions = [
    {
      plan: (user?.subscription || "FREE").toUpperCase(),
      endDate: user?.subscriptionEndDate,
    },
  ];

  if (hasBusinessContext && business) {
    subscriptions.push({
      plan: (business.subscription || "FREE").toUpperCase(),
      endDate: business.subscriptionEndDate,
    });
  }

  const candidates = subscriptions.map(({ plan: rawPlan, endDate }) => {
    const plan = PLAN_MAPPING[rawPlan] || rawPlan;
    const level = PLAN_LEVELS[plan] || 0;
    const parsedEndDate = endDate ? new Date(endDate) : null;
    const isExpired =
      parsedEndDate &&
      !Number.isNaN(parsedEndDate.getTime()) &&
      parsedEndDate < new Date();

    return { plan, level, isExpired };
  });

  const activePlan = candidates
    .filter((candidate) => !candidate.isExpired)
    .sort((a, b) => b.level - a.level)[0];

  if (activePlan?.level > 0) {
    return { ...activePlan, isExpired: false };
  }

  const expiredPlan = candidates
    .filter((candidate) => candidate.isExpired && candidate.level > 0)
    .sort((a, b) => b.level - a.level)[0];

  if (expiredPlan) {
    return { ...expiredPlan, level: 0, isExpired: true };
  }

  return { plan: activePlan?.plan || "FREE", level: 0, isExpired: false };
};
